export function getOrCreateReservationToken(linkId: string): string {

  const storageKey = `paylink:${linkId}:reservation`;

  let token = localStorage.getItem(storageKey);

  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(storageKey, token);
  }

  return token;
}

export function clearReservationToken(linkId: string): void {

  const storageKey = `paylink:${linkId}:reservation`;

  localStorage.removeItem(storageKey);
}